import { ReactElement } from 'react';
import {
  ClickAwayListener as MUIClickAwayListener,
  ClickAwayListenerProps as MUIClickAwayListenerProps,
} from '@mui/material';

type AtomMUIProps = {
  onClickAway: (event: any) => void;
  children: ReactElement<any>;
};

export type ClickAwayListenerProps = AtomMUIProps;

export const ClickAwayListener = (props: ClickAwayListenerProps) => {
  const MUIProps: MUIClickAwayListenerProps = props;

  return <MUIClickAwayListener {...MUIProps} />;
};

export default ClickAwayListener;
